<template>
<div>
  <button class="signout bgSvg" @click="logout">
    <svg width='35' height='42' viewBox='0 0 35 42' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><path d='M6.4126 -0.296997H27.6626C31.2751 -0.296997 34.0376 2.433 34.0376 6.003V18.603H15.7626L20.6501 13.773C21.5001 12.933 21.5001 11.673 20.6501 10.833C19.8001 9.993 18.5251 9.993 17.6751 10.833L9.1751 19.233C8.3251 20.073 8.3251 21.333 9.1751 22.173L17.6751 30.573C18.5251 31.413 19.8001 31.413 20.6501 30.573C21.5001 29.733 21.5001 28.473 20.6501 27.633L15.7626 22.803H34.0376V35.403C34.0376 38.973 31.2751 41.703 27.6626 41.703H6.4126C2.8001 41.703 0.0375977 38.973 0.0375977 35.403V6.003C0.0375977 2.433 2.8001 -0.296997 6.4126 -0.296997Z'/></svg>
  </button>
  <transition name="fadeMenu">
<div class="dropdown" v-if="toggle">
    <div class="input">
        <p>Username</p>
        <div class="input-container">
      <input type="email" placeholder="E-Mail" v-model="name" />
      </div>
      </div>
     <div class="input">
        <p>Company</p>
        <div class="input-container">
      <input type="email" placeholder="E-Mail" v-model="company" />
      </div>
      </div>

  <router-link to="EditPassword">Change Password</router-link>
</div>
  </transition>
<div class="blackout" v-if="toggle" @click="toggleSwitch"></div>

  <div class="wrapper">
    <div class="circle">
      <div class="user"></div>
    </div>
    <h1>{{ name }}</h1>
    <h2>{{ company }}</h2>

    <div class="card">
      <h3>Plan</h3>
      <p>Essential (10 cameras)<br>
        with access control
      </p>
      <!-- <button>Change Plan</button> -->
    </div>

    <!-- Google Account Section -->
    <div class="card google-card">
      <h3>Google Account</h3>
      <template v-if="$store.getters['googleAuth/authenticatedWithGoogle']">
      <p>Signed in as: <strong>{{$store.getters['googleAuth/googleEmail']}}</strong></p>
      <button class="google-btn" @click="$store.dispatch('googleAuth/signOutGoogle')">
        <img class="google-logo" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
        Sign out of Google
      </button>
      </template>
      <template v-else>
      <p>Connect your Google account for additional features.</p>
      <button class="google-btn" @click="$store.dispatch('googleAuth/signInWithGoogle')">
        <img class="google-logo" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
        Sign in with Google
      </button>
      </template>
    </div>

    <div class="card microsoft-card">
      <h3>Microsoft Account</h3>
      <template v-if="$store.getters['googleAuth/authenticatedWithMicrosoft']">
      <p>Signed in as: <strong>{{$store.getters['googleAuth/microsoftEmail']}}</strong></p>
      <button class="microsoft-btn" @click="$store.dispatch('googleAuth/signOutMicrosoft')">
        <img class="microsoft-logo" src="~@/assets/Microsoft_logo.svg" alt="Google logo" />
        Sign out of Microsoft
      </button>
      </template>
      <template v-else>
      <p>Connect your Google account for additional features.</p>
      <button class="microsoft-btn" @click="$store.dispatch('googleAuth/signInWithMicrosoft')">
        <img class="microsoft-logo" src="~@/assets/Microsoft_logo.svg" alt="Microsoft logo" />
        Sign in with Microsoft
      </button>
      </template>
    </div>

    <!-- <button @click="toggleSwitch">Edit account info</button> -->
    <p class="hash">App version: {{hash}}</p>
    <p class="hash">Time: {{time}}</p>
    <router-link to="/Stats" class="hash" v-if="isSoldelEmail">View App Stats</router-link>

  </div>
  </div>
</template>

<script>

import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      toggle: false,
      email: '',
    };
  },
  mounted() {
    Auth.currentUserInfo().then((user) => {
      this.email = user.attributes.email;
    });
    this.$store.dispatch('googleAuth/checkAuthenticatedWithGoogle');
  },

  methods: {
    toggleSwitch() {
      this.toggle = !this.toggle;
    },
    async signOut() {
      try {
        await Auth.signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
    },
    async logout() {
      const email = localStorage.getItem('email');
      const appStats = localStorage.getItem('appStats');
      const deviceSelected = localStorage.getItem('deviceSelected');
      const settings = localStorage.getItem('settings');
      this.signOut();
      localStorage.clear();
      if (email !== null) localStorage.setItem('email', email);
      if (appStats !== null) localStorage.setItem('appStats', appStats);
      if (deviceSelected !== null) localStorage.setItem('deviceSelected', deviceSelected);
      if (settings !== null) localStorage.setItem('settings', settings);
      this.$store.commit('setToken', '');
      this.$store.commit('setLoggedIn', false);
      this.$router.push('/');
    },
  },
  computed: {
    hash() {
      console.log('Git Hash:', process.env.VUE_APP_GIT_HASH);
      return process.env.VUE_APP_GIT_HASH.substring(0, 7);
    },
    time() {
      console.log('Git Time:', process.env.VUE_APP_GIT_TIME);
      return process.env.VUE_APP_GIT_TIME.substring(0, 19);
    },
    name() {
      if (this.$store.state.user.name) {
        return this.$store.state.user.name;
      }
      return '...';
    },
    company() {
      if (this.$store.state.user.organisation) {
        return this.$store.state.user.organisation.replace('_', ' ');
      } return ' ..';
    },
    isSoldelEmail() {
      return this.email.endsWith('@soldelgroup.com');
    },
  },
};
</script>

<style scoped>

.signout {
  background-color: transparent;
  position: absolute;
  top: 19px;
  left: 9px;
  width: 42px;
  height: 42px;
  opacity: 0.9;
}
.signout svg {
  color: var(--error);
}

.dropdown a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
  margin-top: 38px;
}
.input:first-of-type {
  margin-top: 43px;
}

.input-container {
  background: var(--surface);
  box-shadow: var(--shadow);
}

.dropdown{
    display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--surface);
  width: 100vw;
  height: 352px;
  z-index: 4;
  box-shadow: var(--shadow);
  border-radius: 0px 0px 30px 30px;
}
.blackout{
    position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100vw;
  height: 100%;
  background: var(--modal-bg);
}

.card {
  background-color: var(--surface);
  width: 288px;
  /* height: 234px; */
  padding-bottom: 20px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: var(--border-radius);
  margin-top: 20px;
}
.card button {
  margin-top: 42px;
  border-radius: var(--border-radius);
  width: 155px;
  height: 63px;
  background-color: var(--surface-dark);
  font-weight: 500;
  font-size: 20px;
}
.card p {
  margin-top: 16px;
  font-size: 18px;
line-height: 22px;
}

.wrapper button {
  margin-top: 42px;
  border-radius: var(--border-radius);
  width: 197px;
  height: 63px;
  background-color: var(--surface-dark);
  font-weight: 500;
  font-size: 20px;
}

h3 {
  margin-top: 14px;
  font-weight: 500;
  font-size: 21px;
}
h1 {
  margin-top: 18px;
  font-weight: 500;
  font-size: 20px;
}
h2 {
  margin-top: 4px;
  font-size: 16px;
  font-weight: normal;
  color: #CACACA;
}

.hash {
  color: var(--text-faint);
  margin-top: 14px;
}
.hash:nth-of-type(2) {
  margin-top: 4px;
}

.user {
  background-position: center;
  background-repeat: no-repeat;
  width: 56px;
  height: 56px;
  background-image: url("data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.66667 56C4.66667 56 0 56 0 51.3333C0 46.6667 4.66667 32.6667 28 32.6667C51.3333 32.6667 56 46.6667 56 51.3333C56 56 51.3333 56 51.3333 56H4.66667ZM28 28C31.713 28 35.274 26.525 37.8995 23.8995C40.525 21.274 42 17.713 42 14C42 10.287 40.525 6.72601 37.8995 4.10051C35.274 1.475 31.713 0 28 0C24.287 0 20.726 1.475 18.1005 4.10051C15.475 6.72601 14 10.287 14 14C14 17.713 15.475 21.274 18.1005 23.8995C20.726 26.525 24.287 28 28 28Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  margin-top: 24px;
  background-color: var(--surface);
  border-radius: 500px;
}

.google-card,
.microsoft-card {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.google-btn,
.microsoft-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  border-radius: var(--border-radius);
  width: 210px !important;
  height: 48px;
  background-color: var(--surface-dark);
  border: var(--border);
  color: #fff !important;
  font-weight: 500;
  font-size: 18px !important;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0 10px;
}
.google-btn:hover,
.microsoft-btn:hover {
  background: var(--surface-light);
}
.google-logo,
.microsoft-logo {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
</style>
